<div class="selectable-menu-buttons">
  <square-button
    *ngFor="let action of topActions"
    [label]="action.label"
    [labelSuffix]="action.labelSuffix"
    [testId]="'open-door-option-' + (action.action || action.label)"
    [ngClass]="{'selected': isSelected(action)}"
    (click)="onActionClick(action, $event)">
  </square-button>
</div>
